// The account, session and `/api/me` routes (C-33: network I/O lives in `services/` or
// `lib/apiClient`). Each function is the `fetch` its call site made, moved here unchanged and
// returning the `Response` untouched: the callers own their status handling (several branch on a
// 401 or a rejection themselves) rather than taking `lib/apiClient`'s automatic re-login redirect.
import { intentHeaders as rawIntentHeaders } from "../lib/telemetry/intentEmitter.js";

/** `x-intent-id` for `intentId`, or no header (the emitter is JS; typed here for `fetch`). */
const intentHeaders = (intentId: string | null): Record<string, string> =>
  rawIntentHeaders(intentId) as Record<string, string>;

const JSON_HEADERS = { "Content-Type": "application/json" };

/** The user intent a request belongs to, sent as `x-intent-id`. */
export interface IntentOptions {
  intentId?: string | null;
}

/** `GET /api/account`: the signed-in account's profile. */
export function fetchAccount(): Promise<Response> {
  return fetch("/api/account", { credentials: "include" });
}

/** `PATCH /api/account/profile`, carrying the intent that asked for the change. */
export function patchAccountProfile(
  body: Record<string, unknown>,
  { intentId = null }: IntentOptions = {},
): Promise<Response> {
  return fetch("/api/account/profile", {
    method: "PATCH",
    credentials: "include",
    headers: { ...JSON_HEADERS, ...intentHeaders(intentId) },
    body: JSON.stringify(body),
  });
}

/** `POST /auth/logout`, carrying the logout intent's id (the server log line records it). */
export function postLogout({ intentId = null }: IntentOptions = {}): Promise<Response> {
  return fetch("/auth/logout", {
    method: "POST",
    credentials: "include",
    headers: intentHeaders(intentId),
  });
}

/** `GET /api/me`: the session, its flags and the ToS block. */
export function fetchMe(): Promise<Response> {
  return fetch("/api/me", { credentials: "include" });
}
